import React from 'react';
import { useTranslation } from 'react-i18next';

import { Typography } from '@mui/material';
import MediaTypography from 'components/MediaTypography';

import { NotFoundBookWrap } from './styled';

interface PropsType {
	search: string;
}

function BooksNotFound({ search }: PropsType) {
	const { t } = useTranslation();
	return (
		<NotFoundBookWrap>
			<MediaTypography variant="h3">{t('resources.emptySearchTitle', { search })}</MediaTypography>
			<Typography variant="body1">{t('resources.emptySearchSubTitle')}</Typography>
		</NotFoundBookWrap>
	);
}

export default BooksNotFound;
